import React from 'react'
import styled from 'styled-components'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Button, TextField, Typography, Box } from '@material-ui/core'

type AddMemberDialogProps = {
  open: boolean
  onClose: () => void
}

const LabelTypography = styled(Typography)`
  color: #9e9e9e;
`

const AddMemberDialog: React.FC<AddMemberDialogProps> = ({open, onClose}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>このワークスペースにメンバーを招待します</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <form autoComplete="off">
          <TextField label="招待する人のメールアドレス" variant="outlined" multiline rows={4} fullWidth />
        </form>
        <Box mb={1}>
          <LabelTypography variant="caption">複数の人を招待する場合は、ひとりずつメールアドレスを改行してください</LabelTypography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={onClose}>
          招待を送信する
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddMemberDialog